import { lazy } from 'react';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { WithChildren } from '@optimus-web/common';
import { DesignSystemAdoptionMeasurement } from './DSAdoptionMeasurement';

const OpenTelemetryProvider = lazy(async () =>
    import(
        /* webpackChunkName: "OpenTelemetryProvider", webpackExports: "OpenTelemetryProvider" */ '@mews/open-telemetry'
    ).then((module) => ({
        default: module.OpenTelemetryProvider,
    }))
);

const SentryProfiler = lazy(async () =>
    import(/* webpackChunkName: "SentryProfiler", webpackExports: "SentryProfiler" */ '@mews/framework').then(
        (module) => ({
            default: module.SentryProfiler,
        })
    )
);

export const CommanderObservability: React.FC<WithChildren> = ({ children }) => {
    const isSentryTracingEnabled = useFeatureFlag(FeatureFlag.sentryTracingEnabled);
    const isOpenTelemetryEnabled = useFeatureFlag(FeatureFlag.openTelemetryEnabled);
    const isDesignSystemAdoptionMeasurementEnabled = useFeatureFlag(FeatureFlag.designSystemAdoptionMeasurementEnabled);

    return (
        <>
            {isOpenTelemetryEnabled ? <OpenTelemetryProvider /> : null}
            {isSentryTracingEnabled ? <SentryProfiler>{children}</SentryProfiler> : <>{children}</>}
            {isDesignSystemAdoptionMeasurementEnabled ? <DesignSystemAdoptionMeasurement /> : null}
        </>
    );
};
